module.exports = function (StorePickerService, shopLocatorService, settingsService, $window) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.storePicker = StorePickerService;
            scope.shopLocatorService = shopLocatorService;
            scope.searching = true;

            settingsService.getFrontendSetting('StorePages', 'StorePagesRedirect')
                .then((res) => {
                    const storePagesRedirectSettings = JSON.parse(res[0].Value);
                    if (storePagesRedirectSettings && storePagesRedirectSettings.EnableRedirect) {
                        let storePathUrl = storePagesRedirectSettings.RedirectBaseUrl || '';
                        storePathUrl = storePathUrl.toLocaleLowerCase();
                        $window.location.assign(storePathUrl);
                    }
                });

            function getStoredLocation() {
                scope.searching = true;

                shopLocatorService.listSupermarkets({
                    Max: 15,
                    Latitude: scope.store.Latitude,
                    Longitude: scope.store.Longitude
                }).then(function (locations) {
                        scope.storesList = locations;
                        scope.searching = false;
                    });
            }

            scope.triggerOnSelect = function (store) {
                scope.store = store;
                getStoredLocation();
            };

        },
        template: require('./shop-locator-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-locator-directive.js
 **/